import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { css } from 'linaria';
import { darkMode } from '@pocket/web-ui';
import { ProfileIcon } from '@pocket/web-ui';
const avatarStyle = "ajoca6s";
const imageStyle = "i6op735";
const defaultStyle = "dwtruy8";
/**
 * Component to display an avatar image by `src`. Defaults to an icon if no `src`
 * prop is provided. Avatar image will be cropped and centered to fit size specified.
 */

const Avatar = ({
  id,
  src,
  altText,
  size,
  className
}) => {
  const avatarStyleVariables = {
    width: size,
    height: size
  };
  return <span className={classnames(avatarStyle, {
    // note, these class names are depended on by AvatarButton.
    'with-image': !!src,
    default: !src
  }, className)} style={avatarStyleVariables}>
      {src ? <img src={src} alt={altText} className={imageStyle} data-cy={`avatar-image-${id}`} /> : <ProfileIcon className={defaultStyle} data-cy={`avatar-default-${id}`} />}
    </span>;
};

Avatar.propTypes = {
  /**
   * Width/height of the avatar, in px or % (or other css string value). Since the
   * avatar will be square, this value is both width and height.
   */
  size: PropTypes.string,

  /**
   * Provide an id if you have multiple instances per page and need unique
   * identifiers for tests.
   */
  id: PropTypes.string,

  /**
   * The src/url for the avatar image
   */
  src: PropTypes.string,

  /**
   * Alt text to include as a description of the Avatar for non-sighted users
   */
  altText: PropTypes.string,

  /**
   * Classname to be applied to the outer node that can be used to override
   * or supplement styles.
   */
  className: PropTypes.string
};
Avatar.defaultProps = {
  id: '',
  size: '100px',
  src: null,
  altText: 'Your avatar'
};
export default Avatar;

require("./avatar.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./avatar.js");